export const SectionHeading = ({ 
  caption, 
  title, 
  description, 
  align = 'left' 
}) => {
  const alignClass = align === 'center' ? 'text-center' : 'text-left';

  return (
    <div className={`mb-16 ${alignClass}`}>
      {caption && (
        <p className="text-sm uppercase tracking-widest text-primary font-manrope mb-4">
          {caption}
        </p>
      )}
      <h2 className="font-syne text-4xl md:text-5xl font-bold text-white leading-tight">
        {title}
      </h2>
      {description && (
        <p className="mt-4 text-muted-foreground font-manrope text-base md:text-lg max-w-2xl">
          {description}
        </p>
      )}
    </div>
  );
};
